// The simulated window, read out of a run's config snapshot.
//
// It lives in `global_experiment_parameters.SIM_START` / `SIM_END`, so the only way to know it is
// to read the config. Worth carrying into links: Value Opportunity and the SKU × Site page use
// period_to as the decision date, and DEFAULT_PERSONA's period ends 2025-09-01 — past the end of
// a typical run — so the coverage and stockout queries 404 and those charts render empty.
//
// TODO(engineer): the metadata service should expose the window on the execution itself, so a
// link can be built without fetching a 2-11 KB config to read two dates.
// Tracked under keystone-ai/supply-chain-planner#259.
export interface SimulationWindow {
  periodFrom: string;
  periodTo: string;
}

export function simulationWindowOf(configBody: unknown): SimulationWindow | undefined {
  if (typeof configBody !== 'object' || configBody === null) return undefined;

  const params = (configBody as { global_experiment_parameters?: unknown }).global_experiment_parameters;
  if (typeof params !== 'object' || params === null) return undefined;

  const { SIM_START: from, SIM_END: to } = params as { SIM_START?: unknown; SIM_END?: unknown };
  if (typeof from !== 'string' || typeof to !== 'string' || !from || !to) return undefined;

  return { periodFrom: from, periodTo: to };
}
